import PropTypes from 'prop-types';
import cx from 'classnames';
import { CatIconTag } from '@blocks-react/components/Icons/Tag';
import { priceDisplayFormat } from '@app/utils/paymentUtils';
import { amountStringToNumber } from './utils';
import styles from '../StickyCTA.module.scss';

export const variants = {
  DEFAULT: 'default',
  DISCOUNT: 'discount',
  TAX_ITEM: 'tax-item',
  CAT_CREDITS: 'cat-credits',
  CAT_CREDITS_SUB: 'cat-credits-sub',
  AMOUNT_REMAINING_SUB: 'amount_remaining_sub'
};

const variantOptions = {
  [variants.DEFAULT]: {},
  [variants.DISCOUNT]: {
    colored: true,
    icon: <CatIconTag size="sm" className="me-1" data-testid="discountIcon" />
  },
  [variants.TAX_ITEM]: {
    sm: true,
    light: true,
    indent: true
  },
  [variants.CAT_CREDITS]: {
    parenthesisWrapAmount: true,
    colored: true
  },
  [variants.CAT_CREDITS_SUB]: {
    parenthesisWrapAmount: true,
    includeCurrency: true,
    colored: true,
    sm: true
  },
  [variants.AMOUNT_REMAINING_SUB]: {
    includeCurrency: true,
    sm: true
  }
};

export const Row = ({
  label = '',
  amount,
  variant = variants.DEFAULT,
  className,
  forceDisplay = false,
  currency
}) => {
  if (!forceDisplay && (!amount || !amountStringToNumber(amount))) {
    return '';
  }
  const opts = variantOptions[variant];
  const formattedAmount = priceDisplayFormat({
    price: amount,
    currency,
    isNecessaryAddCurrency: opts.includeCurrency,
    useCurrencyParenthesis: false
  });
  const displayAmount = opts.parenthesisWrapAmount
    ? `(${formattedAmount.trim()})`
    : formattedAmount;

  const classes = cx(
    styles['sticky-cta__totals-row'],
    'w-100 d-flex justify-content-between align-items-center',
    className,
    {
      [styles['sm']]: opts.sm,
      'ps-2': opts.indent,
      [styles['light']]: opts.light,
      [styles['colored']]: opts.colored
    }
  );

  return (
    <div className={classes}>
      <span className="d-inline-flex align-items-center">
        {opts.icon ?? ''}
        {label}
      </span>
      <span>{displayAmount}</span>
    </div>
  );
};

Row.propTypes = {
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  amount: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  variant: PropTypes.oneOf(Object.values(variants)),
  className: PropTypes.string,
  forceDisplay: PropTypes.bool,
  currency: PropTypes.string
};
